import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_AGENT_ASSIGNMENT,
    GET_ALL_AGENT_ASSIGNMENTS,
    GET_AGENT_ASSIGNMENT_REQUEST,
    CREATE_AGENT_ASSIGNMENT,
    UPDATE_AGENT_ASSIGNMENT,
    DELETE_AGENT_ASSIGNMENT,
    CLEAR_AGENT_ASSIGNMENT,
    AGENT_ASSIGNMENT_ERROR,
    AGENT_ASSIGNMENT_LOADING
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all agent assignments
export const getAgentAssignments = (params = '') => async dispatch => {
    try {
        dispatch({ type: AGENT_ASSIGNMENT_LOADING });
        
        const res = await axios.get(`${API_URL}/agent-sectors${params}`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_AGENT_ASSIGNMENTS,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: AGENT_ASSIGNMENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get assignments by agent
export const getAssignmentsByAgent = (agentId) => async dispatch => {
    try {
        dispatch({ type: AGENT_ASSIGNMENT_LOADING });
        
        const res = await axios.get(`${API_URL}/agent-assignments?agent=${agentId}`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_AGENT_ASSIGNMENTS,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: AGENT_ASSIGNMENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get assignments by serviceable area
export const getAssignmentsByServiceableArea = (serviceableAreaId) => async dispatch => {
    try {
        dispatch({ type: AGENT_ASSIGNMENT_LOADING });
        
        const res = await axios.get(`${API_URL}/agent-assignments?serviceableArea=${serviceableAreaId}`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_AGENT_ASSIGNMENTS,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: AGENT_ASSIGNMENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get agent assignment by ID
export const getAgentAssignment = (id) => async dispatch => {
    try {
        dispatch({ type: GET_AGENT_ASSIGNMENT_REQUEST });
        
        const res = await axios.get(`${API_URL}/agent-sectors/${id}`);
        if(res.data.success){
            dispatch({
                type: GET_AGENT_ASSIGNMENT,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        };
    } catch (err) {
        dispatch({
            type: AGENT_ASSIGNMENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Create agent assignment
export const createAgentAssignment = (formData) => async dispatch => {
    try {
        dispatch({ type: AGENT_ASSIGNMENT_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.post(`${API_URL}/agent-sectors`, formData, config);
        if(res.data.success){
            dispatch({
                type: CREATE_AGENT_ASSIGNMENT,
                payload: res.data.data
            });
            dispatch(setAlert('Agent assignment created successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to create agent assignment', 'danger'));
        }
        
        dispatch({
            type: AGENT_ASSIGNMENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Update agent assignment
export const updateAgentAssignment = (id, formData) => async dispatch => {
    try {
        dispatch({ type: AGENT_ASSIGNMENT_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.put(`${API_URL}/agent-sectors/${id}`, formData, config);
        
        dispatch({
            type: UPDATE_AGENT_ASSIGNMENT,
            payload: res.data.data
        });
        if(res.data.success){
            dispatch(setAlert('Agent assignment updated successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
        
        return res.data;
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to update agent assignment', 'danger'));
        }
        
        dispatch({
            type: AGENT_ASSIGNMENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Delete agent assignment
export const deleteAgentAssignment = (id) => async dispatch => {
    try {
        dispatch({ type: AGENT_ASSIGNMENT_LOADING });
        
        const res = await axios.delete(`${API_URL}/agent-sectors/${id}`);
        
        dispatch({
            type: DELETE_AGENT_ASSIGNMENT,
            payload: id
        });
        if(res.data.success){
            dispatch(setAlert('Agent assignment deleted successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch({
            type: AGENT_ASSIGNMENT_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        dispatch(setAlert('Failed to delete agent assignment', 'danger'));
    }
};

// Clear agent assignment
export const clearAgentAssignment = () => dispatch => {
    dispatch({ type: CLEAR_AGENT_ASSIGNMENT });
};
